import * as React from "react";

import primaryColour from "../../constants";

function SvgReplay(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={16} height={17} viewBox="0 0 16 17" fill="none" {...props}>
      <path
        d="M3.90562 3.35911L5.01054 4.46403C5.19873 4.65222 5.19873 4.95734 5.01054 5.14553C4.82235 5.33372 4.51724 5.33372 4.32905 5.14553L2.40149 3.21797C2.2133 3.02978 2.2133 2.72466 2.40149 2.53647L4.32905 0.608916C4.51724 0.420726 4.82235 0.420726 5.01054 0.608916C5.19873 0.797105 5.19873 1.10222 5.01054 1.29041L3.90562 2.39533H7.80208C11.7942 2.39533 15.0304 5.63157 15.0304 9.62368C15.0304 13.6158 11.7942 16.852 7.80208 16.852C3.80997 16.852 0.57373 13.6158 0.57373 9.62368C0.57373 9.35754 0.78948 9.14179 1.05562 9.14179C1.32176 9.14179 1.53751 9.35754 1.53751 9.62368C1.53751 13.0835 4.34225 15.8882 7.80208 15.8882C11.2619 15.8882 14.0666 13.0835 14.0666 9.62368C14.0666 6.16385 11.2619 3.35911 7.80208 3.35911H3.90562ZM6.35641 7.45518C6.35641 7.06645 6.79299 6.83771 7.1126 7.05897L10.2449 9.22747C10.5217 9.4191 10.5217 9.82826 10.2449 10.0199L7.1126 12.1884C6.79299 12.4097 6.35641 12.1809 6.35641 11.7922V7.45518Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgReplay;
